import React from 'react';

const Box = ({ num, label, value, className = '', testId }) => (
  <div className={`tax-box ${className}`}>
    <p className="text-[7px] text-gray-600"><span className="font-bold text-gray-900 mr-1">{num}</span>{label}</p>
    <p className="text-[10px] font-medium mt-0.5" data-testid={testId}>{value}</p>
  </div>
);

export const TaxReceipt = ({ data }) => {
  const { check, stub } = data;
  const tax = stub.tax_1099b;
  return (
    <section className="check-panel check-stub" data-testid="check-1099b-stub">
      <div className="flex justify-between items-baseline border-b-2 border-gray-900 pb-1 mb-2">
        <p className="check-serif font-bold text-[12px]">1099-B BARTER EXCHANGE RECEIPT</p>
        <p className="text-[8px] text-gray-600">Proceeds From Broker and Barter Exchange Transactions &middot; Tax year {tax.date_sold?.slice(0, 4)}</p>
      </div>
      <div className="grid grid-cols-4 border-l border-t border-gray-300">
        <Box className="col-span-2 row-span-2" label="PAYER / BARTER EXCHANGE" value={<>{check.bank_name}<br /><span className="text-[8px] text-gray-600">{check.treasury_vault.name} &middot; {check.treasury_vault.address}</span></>} />
        <Box num="1a" label="Description of property" value={tax.box_1a} testId="tax-box-1a" />
        <Box num="1b" label="Date acquired" value={tax.date_acquired || 'Various'} />
        <Box num="1c" label="Date sold or disposed" value={tax.date_sold} />
        <Box num="1d" label="Proceeds" value={`$${Number(tax.box_1d).toFixed(2)}`} testId="tax-box-1d" />
        <Box className="col-span-2" label="RECIPIENT" value={<>{check.payee_name}<br /><span className="text-[8px] text-gray-600">{check.payee_address}</span></>} testId="tax-recipient" />
        <Box num="1e" label="Cost or other basis" value={`$${Number(tax.cost_basis).toFixed(2)}`} />
        <Box num="2" label="Short-term / long-term" value={tax.short_term ? 'Short-term' : 'Long-term'} />
        <Box className="col-span-2" label="DRAWER (TRANSFEROR)" value={check.drawer_name} />
        <Box num="13" label="Bartering" value={`$${Number(tax.box_1d).toFixed(2)}`} testId="tax-box-13" />
        <Box label="Gain / (loss)" value={`$${Number(tax.gain_loss).toFixed(2)}`} />
        <Box className="col-span-2" label="IRC SECTION" value={tax.irc_section} />
        <Box label="Reporting category" value={tax.reporting_category} />
        <Box label="Barter credit ref. / Check no." value={<span className="check-mono text-[8px]">{stub.barter_credit.reference} / {check.check_number}</span>} />
        <Box className="col-span-2" label="1031 RELINQUISHED PROPERTY" value={tax.relinquished_property || '-'} testId="tax-relinquished" />
        <Box className="col-span-2" label="1031 REPLACEMENT PROPERTY" value={tax.replacement_property || '-'} testId="tax-replacement" />
      </div>
      <p className="text-[7px] text-gray-500 mt-1.5 leading-tight">
        Recipient copy. Informational receipt for your records, prepared from BETHCOIN Exchange Market ledger data. Fair market value computed at {check.exchange_rate_display || '1 BETH = $1.00 USD'}. NOT FDIC INSURED - SUBJECT TO LOSS.
      </p>
    </section>
  );
};
